import { render, staticRenderFns } from "./FoliosConfigs.vue?vue&type=template&id=c20aa282"
import script from "./FoliosConfigs.vue?vue&type=script&lang=js"
export * from "./FoliosConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c20aa282')) {
      api.createRecord('c20aa282', component.options)
    } else {
      api.reload('c20aa282', component.options)
    }
    module.hot.accept("./FoliosConfigs.vue?vue&type=template&id=c20aa282", function () {
      api.rerender('c20aa282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/invoices/components/FoliosConfigs.vue"
export default component.exports